export default "<ng-progress id=\"myProgress\"></ng-progress>\r\n<serverRoot-cmp></serverRoot-cmp>\r\n<router-outlet></router-outlet>\r\n";